import { render, staticRenderFns } from "./ListPixels.vue?vue&type=template&id=39e7f170&"
import script from "./ListPixels.vue?vue&type=script&lang=js&"
export * from "./ListPixels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports